
















































import Vue from 'vue'
import { createDefinition } from '../services/stats-client'
import { DefinitoinCreateData } from '../types'
import DefinitionForm from '../components/DefinitionForm.vue'

export default Vue.extend({
  name: 'DefinitionCreate',
  components: {
    DefinitionForm
  },
  data () {
    return {
      isLoading: false,
      clearForm: false
    }
  },
  methods: {
    onSubmit (definition: DefinitoinCreateData) {
      this.isLoading = true
      createDefinition(definition)
        .then(() => {
          this.clearForm = true
          this.$store.commit('global/addNotification', {
            text: 'You successfully created new definition!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onClearForm () {
      this.clearForm = false
    }
  }
})
